// extracted by mini-css-extract-plugin
export default {"linkContainer":"link-cell_linkContainer__GNqsG","link":"link-cell_link__yFT9M","linkColoredText":"link-cell_linkColoredText__u9pjO"};